<template>
    <div id="body">
        <b-container>
            <div class="box-thank_you">
                <img src="@/assets/ver2/thank_you.png" alt="">
            </div>
            <div class="box-button">
                <img class="button-next" src="@/assets/ver2/button_next.png" alt="" @click="$TestApp.goToPage(8)">
                <!-- <img class="button-support" src="@/assets/ver2/support_tutorial.png" alt=""> -->
            </div>
            
        </b-container>
    </div>
</template>

<script>
export default {
    
    components: {
        
    },
    computed: {
       
    },
    data () {
        return {
        }
    },
    watch: {
    },
    methods: {
       
    },
    created() {
    }
}
</script>
<style lang="scss" scoped>
.box-thank_you{
    text-align: center;
    img{
        max-width: 45rem;
    }
}
.box-button {
    text-align: center;
    position: relative;
    top:-2rem;
    .button-next, .button-support {
        position: relative;
        cursor: pointer;
    }
    .button-next {
        max-width: 10rem;
        left: 6rem;
    }
    .button-support {
        max-width: 12rem;
        left: 11rem;
        top: 1rem;
    }
}
</style>